import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import $tabs from '@/utils/tabs'
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'
import getAllOrgNav from '@/config/getMicroApp.js'
import 'assets/scss/global.scss'
import 'assets/scss/reset.scss'
import 'animate.css'

Vue.use(ElementUI)
Vue.config.productionTip = false
// 此处会执行@/utils/tabs里面的代码
Vue.prototype.$tabs = $tabs

addEventListener(
  'message',
  (e) => {
    const msg = e.data || {}
    if (msg && msg.type && msg.type == 'external-ready') 
    {
      // 组织要发送的数据（只做示例，请按需调整，避免发送敏感信息）
      const payload = {
        type: 'external-app-init',
        data: {
          // 建议不要直接发送完整长期 token；示例仅展示如何取值
          keycloakToken: {
            token: store.state.keycloakToken?.token,
            tokenParsed: store.state.keycloakToken?.tokenParsed,
            authServerUrl: store.state.keycloakToken?.authServerUrl,
            realm: store.state.keycloakToken?.realm,
            clientId: store.state.keycloakToken?.clientId,
          },
          currentPersonInfo: store.state.currentPersonInfo,
          currentOrg: store.state.currentOrg,
          pcCommonData: store.state.pcCommonData,
          ts: Date.now(),
        },
      }
      try {
        e.source && e.source.postMessage(payload, e.origin)
      } catch (err) {
        console.warn('回复子页面 message 失败', err)
      }
      return;
    }
    if (
      ![
        'file://',
        'http://vue.mlx',
        'http://localhost:9080',
        'http://localhost:42738',
        'http://localhost:42739',
        'http://localhost:42740',
        'http://localhost:42741',
        'http://localhost:42742',
        'http://localhost:42743',
      ].includes(e.origin)
    ) {
      return false
    }
    console.log(e, 'electron data')
    store.dispatch('setPCCommonData', e.data)
  },
  false
)

Vue.use(VueKeycloakJs, {
  init: {
    checkLoginIframe: false,
    onLoad: 'login-required',
  },
  config: {
    realm:
      (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__.keycloakRealm) ||
      process.env.KEYCLOAK_REALM ||
      'smithy',
    clientId:
      (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__.keycloakClientId) ||
      process.env.KEYCLOAK_CLIENT_ID ||
      'nipponia',
    url:
      (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__.keycloakUrl) ||
      process.env.KEYCLOAK_URL ||
      'http://keycloak.mlx/auth',
  },
  onReady(keycloak) {
    console.log(keycloak, 'fd1212')
    Vue.prototype.$fre = keycloak
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#nipponia-basic')

    store.dispatch('setToken', keycloak)
    getAllOrgNav()
    setInterval(() => {
      // updateToken(分钟)
      keycloak
        .updateToken(60)
        .then((res) => {
          if (res) {
            store.dispatch('setToken', keycloak)
          }
        })
        .catch(() => {})
    }, 1000 * 10)
  },
})
